import { c as _c } from "react/compiler-runtime";
import { uiTestId } from '@7f-ui/test-ids';
import type { ElementType, PropsWithChildren, ReactNode } from 'react';
import type { LoadingButtonProps } from '../../../@7f-ui/ui-components/src/lib/components/button/loading-button';
import { LoadingButton } from '../../../@7f-ui/ui-components/src/lib/components/button/loading-button';
import { cx } from '../../../@7f-ui/ui-components/src/lib/cx';
import type { ButtonAsProps } from '../../../@7f-ui/ui-components/src/lib/polymorphic-props';
type AppStickyFooterProps<TAs extends ElementType> = PropsWithChildren<{
  fixed?: boolean;
  numberOfLines?: number;
  buttonProps?: (LoadingButtonProps & ButtonAsProps<TAs>) & {
    'data-testid'?: string;
  };
  popup?: ReactNode;
}>;
export function AppStickyFooter(t0) {
  const $ = _c(19);
  const {
    children,
    fixed: t1,
    numberOfLines: t2,
    buttonProps,
    popup
  } = t0;
  const fixed = t1 === undefined ? true : t1;
  const numberOfLines = t2 === undefined ? 2 : t2;
  let t3;
  if ($[0] !== fixed) {
    t3 = cx("inset-x-0 bottom-0 z-30 shadow-sticky-footer sm:hidden", {
      fixed
    });
    $[0] = fixed;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = uiTestId("StickyFooter.root");
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = buttonProps?.disabled;
  const t6 = numberOfLines === 2;
  const t7 = numberOfLines === 3;
  let t8;
  if ($[3] !== t5 || $[4] !== t6 || $[5] !== t7) {
    t8 = cx("flex justify-between bg-white p-4 xs:px-6 text-primary", {
      "text-primary/30": t5,
      "xs:py-5": t6,
      "px-4 py-3": t7
    });
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== children) {
    t9 = <div className="flex-1">{children}</div>;
    $[7] = children;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== buttonProps) {
    t10 = buttonProps && <div className="self-center" data-testid={uiTestId("StickyFooter.button")}><LoadingButton {...buttonProps} /></div>;
    $[9] = buttonProps;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== t10 || $[12] !== t8 || $[13] !== t9) {
    t11 = <div className={t8}>{t9}{t10}</div>;
    $[11] = t10;
    $[12] = t8;
    $[13] = t9;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== popup || $[16] !== t11 || $[17] !== t3) {
    t12 = <div className={t3} data-testid={t4}>{popup}{t11}</div>;
    $[15] = popup;
    $[16] = t11;
    $[17] = t3;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  return t12;
}